module.exports = __webpack_public_path__ + "static/media/NSS9.720b8848.jpg";